import React from 'react';
import { useParams, Link } from 'react-router-dom';
import blogPosts from './BlogData';
import './Blog.css';
import { useTranslation } from 'react-i18next';

const BlogDetail = () => {

    const { id } = useParams();
    const { t } = useTranslation();  // Çeviri fonksiyonu
  
    // Blog verilerini dönerken her post için dil çevirisini ekliyoruz
    const translatedBlogPosts = blogPosts.map(post => ({
      ...post,
      title: t(post.title),     // Başlık çevirisi
      short: t(post.short),     // Kısa özet çevirisi (eğer kullanılıyorsa)
      content: t(post.content)  // İçerik çevirisi
    }));
  
    // Seçilen blog yazısını çeviri uygulanmış listeden buluyoruz
    const post = translatedBlogPosts.find((item) => item.id.toString() === id);
  if (!post) return <div>{t("blog.message")}.</div>;

  return (
    <div className="blog-detail">
      <img src={post.image} alt={post.title} className="detail-image" />
      <h1 className="blog-title">{post.title}</h1>
      <p className="blog-content">{post.content}</p>
      <Link to="/blog" className="go-back">← {t("blog.button2")}</Link>
    </div>
  );
};

export default BlogDetail;
